// Pricing plans constants

// Function that returns pricing plans based on billing period
export const getPricingPlans = (billingPeriod) => {
  console.log('Get pricing plans for billing period:', billingPeriod);
  
  // Check billing period validity
  if (billingPeriod !== 'monthly' && billingPeriod !== 'year') {
    console.warn(`Invalid billing period: ${billingPeriod}, falling back to monthly`);
    billingPeriod = 'monthly';
  }
  
  // Yearly discount factor (20% discount)
  const yearlyDiscount = 0.8;
  
  // Base monthly prices
  const baseMonthlyPrices = {
    pro: 20,
    business: 40
  };
  
  // Yearly prices with discount (monthly price * 12 * discount factor)
  const yearlyPrices = {
    pro: Math.round(baseMonthlyPrices.pro * 12 * yearlyDiscount),
    business: Math.round(baseMonthlyPrices.business * 12 * yearlyDiscount)
  };
  
  // Monthly equivalent for yearly payments (yearly price divided by 12)
  const yearlyPricesPerMonth = {
    pro: Math.round((yearlyPrices.pro / 12) * 10) / 10, // Round to one decimal place
    business: Math.round((yearlyPrices.business / 12) * 10) / 10
  };
  
  // Select prices based on billing period
  const prices = billingPeriod === 'monthly' ? baseMonthlyPrices : yearlyPrices;
  
  console.log('Using prices:', prices);
  
  return {
    free: {
      title: 'Free',
      price: '0',
      period: '',
      features: [
        'Store up to 1 application',
        'Basic app analysis',
        'Community support',
        'Manual updates only',
        'No priority in support queue',
        'No automatic updates'
      ],
      buttonText: 'Start Free',
      isDefaultPlan: true
    },
    pro: {
      title: 'Pro',
      price: billingPeriod === 'monthly' ? '20' : yearlyPricesPerMonth.pro.toString(),
      period: billingPeriod === 'monthly' ? '/month' : `/month ($${yearlyPrices.pro}/year)`,
      features: [
        'Up to 3 changes per month',
        'Version updates',
        'Store listing updates',
        'Description & screenshots',
        'Contact info updates',
        'Privacy policy URL updates',
        'Does not include new app uploads'
      ],
      buttonText: 'GET STARTED',
      gradientBg: true
    },
    business: {
      title: 'Business',
      price: billingPeriod === 'monthly' ? '40' : yearlyPricesPerMonth.business.toString(),
      period: billingPeriod === 'monthly' ? '/month' : `/month ($${yearlyPrices.business}/year)`,
      features: [
        'Unlimited changes to existing apps',
        'All Pro features',
        'Unlimited version updates',
        'Unlimited store listing updates',
        'Priority support',
        'Does not include new app uploads'
      ],
      buttonText: 'GET STARTED',
    },
    transfer: {
      title: 'App Transfer',
      price: '399',
      period: 'one-time',
      features: [
        'One-time app transfer service',
        'Transfer to your Google Play account',
        'Full ownership transfer',
        'Complete process handling',
        'Support throughout transfer',
        'No monthly commitment'
      ],
      buttonText: 'BUY NOW',
      specialBg: true
    }
  };
}; 